import { useState } from 'react';
import { motion } from 'framer-motion';
import { findNameMatches, getTopMatches } from '../utils/nameMatchUtils';
import MatchShareableImage from './MatchShareableImage';
import MatchesList from './MatchesList';
import MatchesSearch from './MatchesSearch';
import { NameMatch } from '../types/name';

export default function NameMatches() {
  const [name, setName] = useState('');
  const [matches, setMatches] = useState<NameMatch[]>([]);
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const handleSearch = async () => {
    if (!name.trim()) return;
    
    setLoading(true);
    try {
      const foundMatches = await findNameMatches(name);
      setMatches(getTopMatches(foundMatches));
      setShowResults(true);
    } catch (error) {
      console.error('Error searching matches:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <MatchesSearch
        name={name}
        onNameChange={setName}
        onSearch={handleSearch}
        loading={loading}
      />

      {showResults && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-lg shadow-sm p-6"
        >
          {matches.length > 0 ? (
            <>
              <MatchesList matches={matches} />
              <MatchShareableImage name={name} matches={matches} />
            </>
          ) : (
            <div className="text-center py-8 text-gray-600">
              No matches found for "{name}". Try another name!
            </div>
          )}
        </motion.div>
      )}
    </div>
  );
}